// src/constants/textMasks.ts
var phoneNumberMask = "(999) 999-9999";
var userPinMask = "9999";
var zipCodeMask = "99999";
var hiddenPhoneNumberMask = "(AAA) AAA-AA99";

export { hiddenPhoneNumberMask, phoneNumberMask, userPinMask, zipCodeMask };
